import {
  formatBundleExplosionNumber,
  formatBundleExplosionUnits,
} from '../../../lib/bundleDemandExplosionHelpers';

export function BundleDemandExplosionSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'Bundle SKUs', value: formatBundleExplosionNumber(summary.bundleCount) },
    { label: 'Component SKUs', value: formatBundleExplosionNumber(summary.componentCount) },
    { label: 'Forecast units', value: formatBundleExplosionUnits(summary.totalForecastUnits) },
    { label: 'Exploded component units', value: formatBundleExplosionUnits(summary.totalComponentUnits) },
    { label: 'All exceptions', value: formatBundleExplosionNumber(summary.exceptionCount) },
    {
      label: 'Blank / unmapped',
      value: `${formatBundleExplosionNumber(summary.blankOutputCount)} / ${formatBundleExplosionNumber(summary.unmappedComponentCount)}`,
    },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}


